var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    directives: [{
      name: "text-align",
      rawName: "v-text-align.center",
      modifiers: {
        "center": true
      }
    }, {
      name: "padding",
      rawName: "v-padding.top",
      value: (2),
      expression: "2",
      modifiers: {
        "top": true
      }
    }]
  }, [_c('v-link', [_c('v-logo', {
    attrs: {
      "black": ""
    }
  })], 1), _vm._v(" "), _c('div', [_c('v-text', {
    attrs: {
      "type": "subheadling"
    }
  }, [_vm._v("\n            Набор онлайн-инструментов для успешного бизнеса кредитного брокера\n        ")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ca475794","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/sign/Header.vue
// module id = 1154
// module chunks = 0